// src/config/gaConfig.js
import ReactGA from 'react-ga4';

const trackingID = 'G-QDJHR9BL9Z'; // Reemplaza con tu ID de seguimiento

ReactGA.initialize(trackingID);

export default ReactGA;
